var _linearGradient, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartthings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 0,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#148cf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c6fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#217ffe",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.4 16.2831c1.8559-.5923 3.2-2.3307 3.2-4.3831 0-2.54051-2.0595-4.6-4.6-4.6s-4.6 2.05949-4.6 4.6c0 2.0524 1.3441 3.7908 3.2 4.3831v2.1901c-1.5341.3874-2.8207 1.3968-3.5758 2.7442l-2.0274-.5432c.0021-.0578.0032-.1159.0032-.1742 0-2.5405-2.0595-4.6-4.6-4.6-2.54052 0-4.60001 2.0595-4.60001 4.6s2.05949 4.6 4.60001 4.6c1.4797 0 2.7962-.6986 3.6376-1.7841l2.2629.6064c-.0003.0259-.0005.0518-.0005.0777 0 1.2445.3988 2.3958 1.0756 3.3332l-1.6462 1.9618c-.4208-.1268-.8672-.195-1.3294-.195-2.5405 0-4.6 2.0595-4.6 4.6s2.0595 4.6 4.6 4.6 4.6-2.0595 4.6-4.6c0-1.057-.3565-2.0307-.9558-2.8075l1.4758-1.7588c.7498.3628 1.5911.5663 2.48.5663.8182 0 1.5962-.1724 2.2995-.4829l1.4893 1.9063c-.4979.735-.7888 1.6219-.7888 2.5766 0 2.5405 2.0595 4.6 4.6 4.6s4.6-2.0595 4.6-4.6-2.0595-4.6-4.6-4.6c-.5671 0-1.1103.1026-1.6119.2903l-1.4829-1.898c.7489-.9647 1.1948-2.1764 1.1948-3.4923 0-.0593-.0009-.1184-.0027-.1772l2.177-.6243c.8359 1.1522 2.1933 1.9015 3.7257 1.9015 2.5405 0 4.6-2.0595 4.6-4.6s-2.0595-4.6-4.6-4.6-4.6 2.0595-4.6 4.6l.0001.0363-2.0737.5947c-.7611-1.3041-2.0253-2.2787-3.5264-2.6578zm-1.4-2.5831c.9941 0 1.8-.8059 1.8-1.8s-.8059-1.8-1.8-1.8-1.8.8059-1.8 1.8.8059 1.8 1.8 1.8zm0 13.2c1.6016 0 2.9-1.2984 2.9-2.9s-1.2984-2.9-2.9-2.9-2.9 1.2984-2.9 2.9 1.2984 2.9 2.9 2.9zm13.4-6.4c0 .9941-.8059 1.8-1.8 1.8s-1.8-.8059-1.8-1.8.8059-1.8 1.8-1.8 1.8.8059 1.8 1.8zm-5.8 15c.9941 0 1.8-.8059 1.8-1.8s-.8059-1.8-1.8-1.8-1.8.8059-1.8 1.8.8059 1.8 1.8 1.8zm-13.4-1.8c0 .9941-.8059 1.8-1.8 1.8s-1.8-.8059-1.8-1.8.8059-1.8 1.8-1.8 1.8.8059 1.8 1.8zm-5.8-11.4c.9941 0 1.8-.8059 1.8-1.8s-.8059-1.8-1.8-1.8-1.8.8059-1.8 1.8.8059 1.8 1.8 1.8z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartthings);
export default __webpack_public_path__ + "static/media/smartthings.96ea2f0b81b5c44b21f5ff3d4ead526c.svg";
export { ForwardRef as ReactComponent };